
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Powaimumbaipunecabservice() {



    const cardData =
    {
        keyword: ' Powai Mumbai Pune Cab Service',
        heading: 'Skyline Cabs: Powai Mumbai Pune Cab Service',
        headingDescription: 'Skyline Cabs offers trusted and comfortable Powai Mumbai to Pune Cab Service, ensuring a seamless travel experience between the cities. Whether you are heading to Pune for a business meeting, family occasion, or a weekend escape, our clean and well-maintained cabs driven by professional chauffeurs guarantee a smooth and safe journey. With on-time pickups from Powai, transparent pricing, and 24/7 customer assistance, Skyline Cabs is your dependable partner for intercity travel. Book your Powai to Pune cab today and travel with peace of mind.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Powai to Pune Cab",
    "description": "Skyline Cabs offers reliable and affordable cab services from Powai to Pune. Whether you're traveling for business, leisure, or family visits, we provide a variety of vehicles to meet your needs. Our professional drivers ensure a comfortable and safe journey, making your trip from Powai to Pune smooth and hassle-free."
  },
  {
    "name": "Powai to Pune Cab Fare",
    "description": "Skyline Cabs offers competitive pricing for trips from Powai to Pune. Our transparent pricing includes all taxes, tolls, and other charges, ensuring no hidden fees. Choose from a variety of vehicles that suit your preferences and budget, with guaranteed comfort and a reliable service from start to finish."
  },
  {
    "name": "Powai to Pimpri Cab Fare",
    "description": "Skyline Cabs provides affordable taxi services from Powai to Pimpri, ensuring you get the best value for your money. With a range of vehicle options including economy and luxury rides, you can select the one that fits your needs. Enjoy a smooth, timely journey with experienced drivers who know the best routes to get you to Pimpri efficiently."
  },
  {
    "name": "Powai to Pimpri Chinchwad Cab",
    "description": "Travel from Powai to Pimpri Chinchwad with Skyline Cabs for a comfortable and reliable ride. We offer competitive fares and a fleet of vehicles to accommodate different travel needs. Our expert drivers ensure you reach your destination on time and in comfort, making it the ideal choice for both business and leisure trips."
  },
  {
    "name": "Powai to Baner Cab",
    "description": "Skyline Cabs provides dependable taxi services from Powai to Baner. We offer affordable fares without compromising on comfort or quality. Whether you're traveling for work or leisure, our professional drivers ensure you enjoy a smooth, safe, and timely journey, choosing the best routes for efficiency and ease."
  },
  {
    "name": "Powai to Pune Station Cab",
    "description": "Skyline Cabs offers convenient and affordable taxi services from Powai to Pune Station. Our transparent fares and easy booking system ensure a hassle-free experience. We prioritize your comfort and timeliness, with reliable drivers who will get you to the station safely and on time for your train departure."
  },
  {
    "name": "Powai to Viman Nagar Cab",
    "description": "Book a taxi from Powai to Viman Nagar with Skyline Cabs for a reliable, comfortable, and cost-effective journey. Our fleet includes a variety of vehicles to match your needs, and our professional drivers ensure timely arrivals. Whether for business or personal travel, Skyline Cabs makes your ride smooth and efficient."
  },
  {
    "name": "Powai to Hadapsar Cab",
    "description": "Skyline Cabs provides comfortable taxi services from Powai to Hadapsar. Choose from a range of vehicles based on your preferences and budget, ensuring you have a relaxing and enjoyable trip. Our drivers are experienced, ensuring a safe and smooth ride. Book your cab today and experience the best in service and comfort."
  },
  {
    "name": "Powai to Magarpatta Cab",
    "description": "Skyline Cabs offers reliable and affordable taxi services from Powai to Magarpatta. Our fleet of vehicles ensures that you have a smooth and comfortable journey, whether you're traveling solo or with family or colleagues. We focus on punctuality and safety, providing you with a stress-free ride to your destination."
  },
  {
    "name": "Powai to Hinjewadi Cab Fare",
    "description": "Travel from Powai to Hinjewadi with Skyline Cabs at affordable fares. Our pricing is transparent, with no hidden charges, and we provide reliable services for both business and leisure trips. Enjoy the convenience of booking a taxi with us and rest assured that you’ll reach Hinjewadi comfortably and on time."
  },
  {
    "name": "Cab Service in Powai Mumbai",
    "description": "Skyline Cabs offers reliable and affordable cab services in Powai, Mumbai. Whether you need a ride for a local trip or an outstation journey, our fleet of vehicles is ready to cater to your needs. Our well-trained drivers ensure you have a safe and comfortable ride at all times."
  },
  {
    "name": "Powai to Pune Ertiga Taxi",
    "description": "For a comfortable and spacious ride from Powai to Pune, Skyline Cabs offers Ertiga taxi services. Ideal for families or small groups, the Ertiga provides ample space and a smooth journey. Enjoy affordable rates, reliable service, and a comfortable ride with experienced drivers who prioritize your safety and comfort."
  },
  {
    "name": "Powai to Pune Innova Crysta",
    "description": "Skyline Cabs provides premium Innova Crysta taxis for your journey from Powai to Pune. Experience luxury, comfort, and space in one of the most popular vehicles for outstation trips. Whether you're traveling for business or leisure, our experienced drivers will ensure you have a smooth, safe, and enjoyable ride."
  },
  {
    "name": "Powai to Pune Round Trip Taxi",
    "description": "Skyline Cabs offers reliable round trip taxi services from Powai to Pune. Whether you need a one-day or multi-day trip, our round trip service provides you with a convenient and comfortable solution. Choose from a range of vehicles based on your needs, and enjoy a safe, timely, and affordable journey back and forth."
  },
  {
    "name": "Cab Service in Powai Mumbai",
    "description": "Skyline Cabs offers dependable and affordable taxi services within Powai, Mumbai. Whether you're going to the airport, visiting family, or need to travel across the city, our fleet of well-maintained vehicles is ready to meet your needs. Enjoy a safe, comfortable, and stress-free ride with our professional drivers."
  },
  {
    "name": "Taxi Service in Powai Mumbai",
    "description": "Skyline Cabs provides reliable and affordable taxi services throughout Powai, Mumbai. Whether you're booking a local ride or an outstation trip, we ensure timely, safe, and comfortable service. Our fleet of vehicles includes everything from sedans to SUVs, and we offer flexible options for both individuals and groups."
  },
  {
    "name": "Cheapest Taxi Service in Powai Mumbai",
    "description": "Looking for the most affordable taxi services in Powai, Mumbai? Skyline Cabs offers the cheapest taxi services without compromising on quality or comfort. Whether it's a local trip or a long-distance journey, our transparent pricing ensures you get the best value for your money while enjoying top-notch service."
  },
  {
    "name": "Best Taxi Service in Powai Mumbai",
    "description": "Skyline Cabs is proud to offer the best taxi service in Powai, Mumbai. We prioritize customer satisfaction, offering reliable, safe, and comfortable rides with professional drivers. Whether you're heading to the airport, attending a meeting, or going on an outstation trip, Skyline Cabs provides the best value, comfort, and service every time."
  }
],
"tableData": [
  ["Powai to Pune Cab", "Powai to Pune Cab Fare"],
  ["Powai to Pimpri Cab Fare", "Powai to Pimpri Chinchwad Cab"],
  ["Powai to Baner Cab", "Powai to Pune Station Cab"],
  ["Powai to Viman Nagar Cab", "Powai to Hadapsar Cab"],
  ["Powai to Magarpatta Cab", "Powai to Hinjewadi Cab Fare"],
  ["Cab Service in Powai Mumbai", "Powai to Pune Ertiga Taxi"],
  ["Powai to Pune Innova Crysta", "Powai to Pune Round Trip Taxi"],
  ["Cab Service in Powai Mumbai", "Taxi Service in Powai Mumbai"],
  ["Cheapest Taxi Service in Powai Mumbai", "Best Taxi Service in Powai Mumbai"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Powai to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and timely cab services from Powai to Pune, ensuring you reach your destination on time, every time. Whether you’re traveling for business, leisure, or any other purpose, we guarantee a smooth and comfortable ride."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained vehicles, including sedans, SUVs, and luxury cars, designed to provide you with a comfortable and relaxing journey. All our cars are air-conditioned and spacious, ensuring a pleasant trip from Powai to Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are trained in safe driving practices and are familiar with the best routes from Powai to Pune. They ensure your safety, comfort, and punctuality throughout the ride, offering you a pleasant and stress-free experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive and transparent pricing for your Powai to Pune journey. You’ll know the cost upfront with no hidden charges, ensuring you get great value for money while enjoying top-quality service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs is available 24/7, meaning you can book a ride from Powai to Pune at any time, day or night. Whether it’s an early morning departure or a late-night return, we are ready to serve you whenever you need us."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your cab is easy and quick with Skyline Cabs. Use our website or mobile app to book your ride in just a few clicks and receive instant booking confirmation along with real-time tracking of your ride."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "We prioritize your health and safety. All of our vehicles are thoroughly sanitized before each ride, and our drivers follow strict safety protocols to ensure that you travel in a safe, clean, and hygienic environment."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Whether you're traveling alone, with family, or in a group, Skyline Cabs offers a range of vehicles to suit your needs. From comfortable sedans for solo travelers to larger SUVs for groups, we ensure a smooth and comfortable journey from Powai to Pune."
    }
]



















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Powai Mumbai to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Powai Mumbai to Pune is simple and quick. You can book through our website, mobile app, or by calling our customer support team. Just enter your pickup and drop-off details, select your preferred vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Powai Mumbai to Pune trip?',
            answer:
                'We offer a variety of vehicles to suit your preferences, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the vehicle based on the number of passengers and your comfort requirements.',
        },
        {
            id: 3,
            question: 'How long will it take to travel from Powai Mumbai to Pune?',
            answer:
                'The travel time from Powai Mumbai to Pune typically ranges from 3.5 to 5 hours, depending on traffic conditions. Our professional drivers take the best routes to ensure you have a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares for the Powai Mumbai to Pune cab fixed?',
            answer:
                'Yes, our fares are fixed, and we provide upfront pricing, including tolls, taxes, and driver fees. You’ll know the total cost before confirming your booking, ensuring complete transparency.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab service from Powai Mumbai to Pune?',
            answer:
                'Yes, you can easily book a round-trip cab. Simply provide your return trip details while booking, and we’ll take care of the rest, ensuring a comfortable return journey as well.',
        },
        {
            id: 6,
            question: 'Can I make modifications to my Powai Mumbai to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking via our website, app, or by contacting our customer support team. We offer flexible options to accommodate changes and cancellations.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Powai Mumbai to Pune well-maintained?',
            answer:
                'Absolutely! We ensure that all our vehicles are regularly maintained and thoroughly cleaned. We prioritize comfort and safety, ensuring you have a pleasant and worry-free ride.',
        },
        {
            id: 8,
            question: 'What payment options are available for my Powai Mumbai to Pune cab?',
            answer:
                'We offer secure online payment options such as credit/debit cards, UPI, and net banking. Alternatively, you can choose to pay in cash at the end of your ride.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs available for corporate travel from Powai Mumbai to Pune?',
            answer:
                'Yes, Skyline Cabs offers corporate travel services, providing reliable and comfortable transport for business meetings, conferences, or group travel. Contact us for tailored services that meet your corporate needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Powai Mumbai to Pune journey?',
            answer:
                'Skyline Cabs is known for its professional drivers, well-maintained vehicles, affordable pricing, and excellent customer service. We prioritize comfort, safety, and timely arrivals, ensuring you have a smooth, hassle-free journey from Powai Mumbai to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I traveled from Powai Mumbai to Pune for a weekend trip, and Skyline Cabs made it a comfortable experience. The car was clean and well-maintained, and the driver was polite and professional. I’ll definitely book again!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Had a good experience with Skyline Cabs for my Powai Mumbai to Pune journey. The ride was smooth, and the driver was punctual. It would’ve been perfect if the AC was a little cooler, but overall, I’m satisfied with the service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Powai to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/powai-to-pune-cab.jpg",
  "description": "Book Powai to Pune cab with Skyline Cabs for a smooth and reliable ride. Choose from AC sedans or SUVs driven by verified drivers—available 24/7 for one-way and round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7452"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/powai-to-pune-cab"
  }
};



      
     
      


    return (
        <div>
<Helmet>
  <title>Powai to Pune Cab | 24/7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Powai to Pune cab with Skyline Cabs for a smooth and reliable ride. Choose from AC sedans or SUVs driven by verified drivers—available 24/7 for one-way and round-trip journeys." 
  />
  <meta 
    name="keywords" 
    content="Powai to Pune Cab, Cab from Powai to Pune, One-Way Taxi Powai to Pune, Round Trip Cab Powai to Pune, AC Cab Powai to Pune, SUV Taxi Powai to Pune, Affordable Taxi Powai to Pune, Online Cab Booking Powai to Pune, 24/7 Taxi Powai to Pune, Skyline Cabs Powai to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/49.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Powaimumbaipunecabservice;